// Erc20 ABI
export const ERC20Abi = `[{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"balance","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"payable":true,"stateMutability":"payable","type":"fallback"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"}]`;
export const USDTAbi = `[{"type":"event","name":"Approval","inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}]},{"type":"event","name":"Transfer","inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}]},{"type":"function","name":"allowance","stateMutability":"view","inputs":[{"name":"owner","type":"address"},{"name":"spender","type":"address"}],"outputs":[{"name":"","type":"uint256"}]},{"type":"function","name":"approve","stateMutability":"nonpayable","inputs":[{"name":"spender","type":"address"},{"name":"amount","type":"uint256"}],"outputs":[{"name":"","type":"bool"}]},{"type":"function","name":"balanceOf","stateMutability":"view","inputs":[{"name":"account","type":"address"}],"outputs":[{"name":"","type":"uint256"}]},{"type":"function","name":"decimals","stateMutability":"view","inputs":[],"outputs":[{"name":"","type":"uint8"}]},{"type":"function","name":"name","stateMutability":"view","inputs":[],"outputs":[{"name":"","type":"string"}]},{"type":"function","name":"symbol","stateMutability":"view","inputs":[],"outputs":[{"name":"","type":"string"}]},{"type":"function","name":"totalSupply","stateMutability":"view","inputs":[],"outputs":[{"name":"","type":"uint256"}]},{"type":"function","name":"transfer","stateMutability":"nonpayable","inputs":[{"name":"recipient","type":"address"},{"name":"amount","type":"uint256"}],"outputs":[]},{"type":"function","name":"transferFrom","stateMutability":"nonpayable","inputs":[{"name":"sender","type":"address"},{"name":"recipient","type":"address"},{"name":"amount","type":"uint256"}],"outputs":[{"name":"","type":"bool"}]}]`;

// Cutoff value in USD
export const ValueCutoff = 1e-2;
// Cutoff value in ETH
export const EthValueCutoff = 1e-5;
// Cutoff value in other tokens
export const TokenValueCutoff = 1e-3;

export interface iToken {
  id: string;
  precision: number;
  alias: string;
  isStable: boolean;
  addr?: string;
  showInWallet?: boolean;
}

// TokenMap
export const TokenAddrMap = new Map<string, iToken>([
  // Stable coins
  [
    '0xeb269732ab75a6fd61ea60b06fe994cd32a83549',
    { isStable: true, id: 'USDx', alias: '', precision: 1e18 },
  ],
  [
    '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    { isStable: true, id: 'USDC', alias: '', precision: 1000000 },
  ],
  [
    '0xdac17f958d2ee523a2206206994597c13d831ec7',
    { isStable: true, id: 'USDT', alias: '', precision: 1000000 },
  ],
  [
    '0xdf574c24545e5ffecb9a659c229253d4111d87e1',
    { isStable: true, id: 'HUSD', alias: '', precision: 100000000 },
  ],
  [
    '0x4fabb145d64652a948d72533023f6e7a623c7c53',
    { isStable: true, id: 'BUSD', alias: '', precision: 1e18 },
  ],
  [
    '0x0000000000085d4780b73119b644ae5ecd22b376',
    { isStable: true, id: 'TUSD', alias: '', precision: 1e18 },
  ],
  [
    '0x8e870d67f660d95d5be530380d0ec0bd388289e1',
    { isStable: true, id: 'PAX', alias: '', precision: 1e18 },
  ],
  [
    '0x056fd409e1d7a124bd7017459dfea2f387b6d5cd',
    { isStable: true, id: 'GUSD', alias: '', precision: 100.0 },
  ],
  [
    '0x1c48f86ae57291f7686349f12601910bd8d470bb',
    { isStable: true, id: 'USDK', alias: '', precision: 1e18 },
  ],
  [
    '0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359',
    { isStable: true, id: 'SAI', alias: '', precision: 1e18 },
  ],
  [
    '0x6b175474e89094c44da98b954eedeac495271d0f',
    { isStable: true, id: 'DAI', alias: '', precision: 1e18 },
  ],

  // Is stable to turkey curreny, assume not stable for now
  [
    '0x2c537e5624e4af88a7ae4060c022609376c8d0eb',
    { isStable: false, id: 'TRYB', alias: '', precision: 1e6 },
  ],

  // normal coins
  [
    '0x000000000000000000000000000000000000000e',
    { isStable: false, id: 'ETH', alias: '', precision: 1e18 },
  ],
  [
    '0x0000000000000000000000000000000000000000',
    { isStable: false, id: 'ETH', alias: '', precision: 1e18 },
  ],
  [
    '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
    { isStable: false, id: 'ETH', alias: '', precision: 1e18 },
  ],
  [
    '0xb8c77482e45f1f44de1745f52c74426c631bdd52',
    { isStable: false, id: 'BNB', alias: '', precision: 1e18 },
  ],
  [
    '0xdd974d5c2e2928dea5f71b9825b8b646686bd200',
    { isStable: false, id: 'KNC', alias: '', precision: 1e18 },
  ],
  [
    '0x514910771af9ca656af840dff83e8264ecf986ca',
    { isStable: false, id: 'LINK', alias: '', precision: 1e18 },
  ],
  [
    '0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f',
    { isStable: false, id: 'SNX', alias: '', precision: 1e18, showInWallet: false },
  ],
  [
    '0x1985365e9f78359a9b6ad760e32412f4a445e862',
    { isStable: false, id: 'REP', alias: '', precision: 1e18 },
  ],
  [
    '0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2',
    { isStable: false, id: 'MKR', alias: '', precision: 1e18 },
  ],
  [
    '0xe41d2489571d322189246dafa5ebde1f4699f498',
    { isStable: false, id: 'ZRX', alias: '', precision: 1e18 },
  ],
  [
    '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
    { isStable: false, id: 'WETH', alias: 'ETH', precision: 1e18 },
  ],
  [
    '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
    { isStable: false, id: 'WBTC', alias: '', precision: 100000000 },
  ],
  [
    '0x3212b29e33587a00fb1c83346f5dbfa69a458923',
    { isStable: false, id: 'imBTC', alias: '', precision: 100000000 },
  ],
  [
    '0x0316eb71485b0ab14103307bf65a021042c6d380',
    { isStable: false, id: 'HBTC', alias: '', precision: 1e18 },
  ],
  [
    '0xf53ad2c6851052a81b42133467480961b2321c09',
    { isStable: false, id: 'PETH', alias: '', precision: 1e18 },
  ],
  [
    '0x0d8775f648430679a709e98d2b0cb6250d2887ef',
    { isStable: false, id: 'BAT', alias: '', precision: 1e18 },
  ],
  [
    '0x9af839687f6c94542ac5ece2e317daae355493a1',
    { isStable: false, id: 'HOT', alias: '', precision: 1e18 },
  ],
  [
    '0x6f259637dcd74c767781e37bc6133cd6a68aa161',
    { isStable: false, id: 'HT', alias: '', precision: 1e18 },
  ],
  [
    '0xf1290473e210b2108a85237fbcd7b6eb42cc654f',
    { isStable: false, id: 'HEDG', alias: '', precision: 1e18 },
  ],
  [
    '0x75231f58b43240c9718dd58b4967c5114342a86c',
    { isStable: false, id: 'OKB', alias: '', precision: 1e18 },
  ],
  [
    '0xa0b73e1ff0b80914ab6fe0444e65848c4c34450b',
    { isStable: false, id: 'CRO', alias: '', precision: 1e8 },
  ],
  [
    '0xd850942ef8811f2a866692a623011bde52a462c1',
    { isStable: false, id: 'VEN', alias: '', precision: 1e18 },
  ],
  [
    '0xc9859fccc876e6b4b3c749c5d29ea04f48acb74f',
    { isStable: false, id: 'INO', alias: '', precision: 1 },
  ],
  [
    '0xb5a5f22694352c15b00323844ad545abb2b11028',
    { isStable: false, id: 'ICX', alias: '', precision: 1e18 },
  ],
  [
    '0x8e766f57f7d16ca50b4a0b90b88f6468a09b0439',
    { isStable: false, id: 'MXM', alias: '', precision: 1e18 },
  ],
  [
    '0x17aa18a4b64a55abed7fa543f2ba4e91f2dce482',
    { isStable: false, id: 'INB', alias: '', precision: 1e18 },
  ],
  [
    '0xd26114cd6EE289AccF82350c8d8487fedB8A0C07',
    { isStable: false, id: 'OMG', alias: '', precision: 1e18 },
  ],
  [
    '0x6c6ee5e31d828de241282b9606c8e98ea48526e2',
    { isStable: false, id: 'holotoken', alias: '', precision: 1e18 },
  ],
  [
    '0x3883f5e181fccaf8410fa61e12b59bad963fb645',
    { isStable: false, id: 'THETA', alias: '', precision: 1e18 },
  ],
  [
    '0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206',
    { isStable: false, id: 'NEXO', alias: '', precision: 1e18 },
  ],
  [
    '0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c',
    { isStable: false, id: 'ENJ', alias: '', precision: 1e18 },
  ],
  [
    '0x039b5649a59967e3e936d7471f9c3700100ee1ab',
    { isStable: false, id: 'KCS', alias: '', precision: 1e6 },
  ],
  [
    '0xcb97e65f07da24d46bcdd078ebebd7c6e6e3d750',
    { isStable: false, id: 'BTM', alias: '', precision: 1e8 },
  ],
  [
    '0xe0b7927c4af23765cb51314a0e0521a9645f0e2a',
    { isStable: false, id: 'DGD', alias: '', precision: 1e12 },
  ],
  [
    '0xbd0793332e9fb844a52a205a233ef27a5b34b927',
    { isStable: false, id: 'ZB', alias: '', precision: 1e18 },
  ],
  [
    '0x653430560be843c4a3d143d0110e896c2ab8ac0d',
    { isStable: false, id: 'MOF', alias: '', precision: 1e16 },
  ],
  [
    '0x973e52691176d36453868d9d86572788d27041a9',
    { isStable: false, id: 'DX', alias: '', precision: 1e18 },
  ],
  [
    '0xb63b606ac810a52cca15e44bb630fd42d8d1d83d',
    { isStable: false, id: 'MCO', alias: '', precision: 1e8 },
  ],
  [
    '0x1122b6a0e00dce0563082b6e2953f3a943855c1f',
    { isStable: false, id: 'CENNZ', alias: '', precision: 1e18 },
  ],
  [
    '0xfa1a856cfa3409cfa145fa4e20eb270df3eb21ab',
    { isStable: false, id: 'IOST', alias: '', precision: 1e18 },
  ],
  [
    '0x8ce9137d39326ad0cd6491fb5cc0cba0e089b6a9',
    { isStable: false, id: 'SXP', alias: '', precision: 1e18 },
  ],
  [
    '0x05f4a42e251f2d52b8ed15e9fedaacfcef1fad27',
    { isStable: false, id: 'ZIL', alias: '', precision: 1e12 },
  ],
  [
    '0xa74476443119A942dE498590Fe1f2454d7D4aC0d',
    { isStable: false, id: 'GNT', alias: '', precision: 1e18 },
  ],
  [
    '0xbf2179859fc6d5bee9bf9158632dc51678a4100e',
    { isStable: false, id: 'ELF', alias: '', precision: 1e18 },
  ],
  [
    '0x3506424f91fd33084466f402d5d97f05f8e3b4af',
    { isStable: false, id: 'CHZ', alias: '', precision: 1e18 },
  ],
  [
    '0xb1eef147028e9f480dbc5ccaa3277d417d1b85f0',
    { isStable: false, id: 'Seele', alias: '', precision: 1e18 },
  ],
  [
    '0x5ca9a71b1d01849c0a95490cc00559717fcf0d1d',
    { isStable: false, id: 'AE', alias: '', precision: 1e18 },
  ],
  [
    '0x0f5d2fb29fb7d3cfee444a200298f468908cc942',
    { isStable: false, id: 'MANA', alias: '', precision: 1e18 },
  ],
  [
    '0x58a4884182d9e835597f405e5f258290e46ae7c2',
    { isStable: false, id: 'NOAH', alias: '', precision: 1e18 },
  ],
  [
    '0x744d70fdbe2ba4cf95131626614a1763df805b9e',
    { isStable: false, id: 'SNT', alias: '', precision: 1e18 },
  ],
  [
    '0x39bb259f66e1c59d5abef88375979b4d20d98022',
    { isStable: false, id: 'WAX', alias: '', precision: 1e8 },
  ],
  [
    '0x2af5d2ad76741191d15dfe7bf6ac92d4bd912ca3',
    { isStable: false, id: 'LEO', alias: '', precision: 1e18 },
  ],
  [
    '0xa974c709cfb4566686553a20790685a47aceaa33',
    { isStable: false, id: 'XIN', alias: '', precision: 1e18 },
  ],
  [
    '0x06af07097c9eeb7fd685c692751d5c66db49c215',
    { isStable: false, id: 'CHAI', alias: '', precision: 1e18 },
  ],
  [
    '0x4f3afec4e5a3f2a6a1a411def7d7dfe50ee057bf',
    { isStable: false, id: 'DGX', alias: '', precision: 1e9 },
  ],

  // SNX TOKENS
  [
    '0x617aecb6137b5108d1e7d4918e3725c8cebdb848',
    { isStable: false, id: 'sBNB', alias: '', precision: 1e18 },
  ],
  [
    '0x5e74c9036fb86bd7ecdcb084a0673efc32ea31cb',
    { isStable: false, id: 'sETH', alias: '', precision: 1e18 },
  ],
  [
    '0xfe18be6b3bd88a2d2a7f928d00292e7a9963cfc6',
    { isStable: false, id: 'sBTC', alias: '', precision: 1e18 },
  ],
  [
    '0xbbc455cb4f1b9e4bfc4b73970d360c8f032efee6',
    { isStable: false, id: 'sLINK', alias: '', precision: 1e18 },
  ],
  [
    '0xe1afe1fd76fd88f78cbf599ea1846231b8ba3b6b',
    { isStable: false, id: 'sDEFI', alias: '', precision: 1e18 },
  ],
  [
    '0xa2B0fDe6D710e201d0d608e924A484d1A5fEd57c',
    { isStable: false, id: 'sXRP', alias: '', precision: 1e18 },
  ],
  [
    '0x27269b3e45a4d3e79a3d6bfee0c8fb13d0d711a6',
    { isStable: false, id: 'sTRX', alias: '', precision: 1e18 },
  ],
  [
    '0x57Ab1E02fEE23774580C119740129eAC7081e9D3',
    { isStable: false, id: 'sUSD', alias: '', precision: 1e18 },
  ],

  // SNX itokens
  [
    '0xafd870f32ce54efdbf677466b612bf8ad164454b',
    { isStable: false, id: 'iBNB', alias: '', precision: 1e18 },
  ],
  [
    '0xd6014ea05bde904448b743833ddf07c3c7837481',
    { isStable: false, id: 'iBTC', alias: '', precision: 1e18 },
  ],
  [
    '0x2d7ac061fc3db53c39fe1607fb8cec1b2c162b01',
    { isStable: false, id: 'iLINK', alias: '', precision: 1e18 },
  ],
  [
    '0x14d10003807ac60d07bb0ba82caeac8d2087c157',
    { isStable: false, id: 'iDEFI', alias: '', precision: 1e18 },
  ],
  [
    '0xa9859874e1743a32409f75bb11549892138bba1e',
    { isStable: false, id: 'iETH', alias: '', precision: 1e18 },
  ],
  [
    '0x79da1431150c9b82d2e5dfc1c68b33216846851e',
    { isStable: false, id: 'iLTC', alias: '', precision: 1e18 },
  ],
  [
    '0x27269b3e45a4d3e79a3d6bfee0c8fb13d0d711a6',
    { isStable: false, id: 'iXRP', alias: '', precision: 1e18 },
  ],
  [
    '0xc5807183a9661a533cb08cbc297594a0b864dc12',
    { isStable: false, id: 'iTRX', alias: '', precision: 1e18 },
  ],
  [
    '0xC14103C2141E842e228FBaC594579e798616ce7A',
    { isStable: false, id: 'sLTC', alias: '', precision: 1e18 },
  ],

  // CTokens
  [
    '0x39aa39c021dfbae8fac545936693ac917d5e7563',
    { isStable: false, id: 'cUSDC', alias: '', precision: 1e8, showInWallet: false },
  ],
  [
    '0x5d3a536e4d6dbd6114cc1ead35777bab948e3643',
    { isStable: false, id: 'cDAI', alias: '', precision: 1e8, showInWallet: false },
  ],
]);

export const TokenIDMap = new Map<string, iToken>(
  Array.from(TokenAddrMap.entries()).map(([addr, itoken]) => {
    return [itoken.id.toLowerCase(), { ...itoken, addr }];
  }),
);

export function GetTokenByName(id: string) {
  return TokenIDMap.get(id.toLocaleLowerCase());
}
